import { actionCreator } from '../helpers/actionCreator';
import { E_USERS_ACTION_TYPES } from './actionTypes';
export var usersActions = {
    fetchUsersRequested: function () { return actionCreator(E_USERS_ACTION_TYPES.FETCH_USERS_REQUESTED); },
    fetchUsersSucceeded: function (users) { return actionCreator(E_USERS_ACTION_TYPES.FETCH_USERS_SUCCEEDED, { users: users }); },
    updateUsersCollectionLoading: function (isLoading) {
        return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USERS_COLLECTION_LOADING, { isLoading: isLoading });
    },
    saveAllColumns: function (allColumns) { return actionCreator(E_USERS_ACTION_TYPES.SAVE_USERS_ALL_COLUMNS, { allColumns: allColumns }); },
    updateColumn: function (columns) { return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USERS_COLUMN, { columns: columns }); },
    updateUsersFilterRequested: function (filters) {
        return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USERS_FILTERS_REQUESTED, { filters: filters });
    },
    updateUsersFilterSucceeded: function (filters) {
        return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USERS_FILTERS_SUCCEEDED, { filters: filters });
    },
    exportUsersInCSVRequested: function () { return actionCreator(E_USERS_ACTION_TYPES.EXPORT_USERS_IN_CSV_REQUESTED); },
    importUsersInCSVRequested: function (file) { return actionCreator(E_USERS_ACTION_TYPES.IMPORT_USERS_IN_CSV_REQUESTED, { file: file }); },
    importUsersInCSVSucceeded: function (result) { return actionCreator(E_USERS_ACTION_TYPES.IMPORT_USERS_IN_CSV_SUCCEEDED, { result: result }); },
    updateUsersImportLoading: function (isLoading) {
        return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USERS_IMPORT_LOADING, { isLoading: isLoading });
    },
    clearUsersImport: function () { return actionCreator(E_USERS_ACTION_TYPES.CLEAR_USERS_IMPORT); },
    fetchCurrentUserDetailsRequested: function (userId) {
        return actionCreator(E_USERS_ACTION_TYPES.FETCH_CURRENT_USER_DETAILS_REQUESTED, { userId: userId });
    },
    fetchCurrentUserDetailsSucceeded: function (user) {
        return actionCreator(E_USERS_ACTION_TYPES.FETCH_CURRENT_USER_DETAILS_SUCCEEDED, { user: user });
    },
    clearCurrentUser: function () { return actionCreator(E_USERS_ACTION_TYPES.CLEAR_CURRENT_USER); },
    updateUserRequested: function (user) { return actionCreator(E_USERS_ACTION_TYPES.UPDATE_USER_REQUESTED, { user: user }); },
    deleteUserRequested: function (user) { return actionCreator(E_USERS_ACTION_TYPES.DELETE_USER_REQUESTED, { user: user }); },
};
